import { render, staticRenderFns } from "./screen-3.vue?vue&type=template&id=4ef8d99e&scoped=true&"
import script from "./screen-3.vue?vue&type=script&lang=js&"
export * from "./screen-3.vue?vue&type=script&lang=js&"
import style0 from "./screen-3.vue?vue&type=style&index=0&id=4ef8d99e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef8d99e",
  null
  
)

export default component.exports